



import '@toast-ui/editor/dist/toastui-editor-viewer.css';

import { Viewer } from '@toast-ui/vue-editor';

export default {
  components: {
    viewer: Viewer
  },
  props: {
    data: {
      type: String
    },
  },
  watch: {
    data(newValue) {
      this.$refs.toastuiEditorViewer.invoke('setMarkdown', newValue);
    }
  }
};
